<template>
  <div>
    <button
      v-for="(sound, index) in sounds"
      :key="index"
      @click="onClick(sound.file)"
      :class="{
        'active': isActive(sound.file)
      }"
    >
      {{ sound.name }}
    </button>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import {NS_GAME_STATE} from "@/store/constants";

export default {
  name: 'SoundEffects',

  data() {
    return {
      sounds: [
        {
          name: 'Come on baby',
          file: 'your-turn.mp3',
        },
        {
          name: 'Bling',
          file: 'coin.mp3',
        },
        {
          name: 'The BASS',
          file: 'deep-bass.mp3',
        },
        {
          name: 'Generic Ass Sound',
          file: 'generic-app.mp3',
        },
        {
          name: 'Happy Beep',
          file: 'happy-beep.mp3',
        },
        {
          name: 'Happy Boop',
          file: 'happy.mp3',
        },
      ]
    }
  },

  computed: {
    ...mapState(NS_GAME_STATE, [
      'soundFile'
    ]),
  },

  methods: {
    ...mapMutations(NS_GAME_STATE, [
      'setSoundFile'
    ]),

    onClick(file) {
      if (this.soundFile.sound) {
        this.soundFile.sound.pause();
      }

      this.setSoundFile({
        fileName: file,
        sound: new Audio(`/sounds/${file}`)
      });

      this.soundFile.sound.play()
        .then(ok => {
          console.log('Sound Played', ok);
        })
        .catch(error => {
          console.log('Sound Failed to play', error);
        })
    },

    isActive(file) {
      return file === this.soundFile.fileName;
    }
  }
}
</script>

<style scoped>
.active {
  background: blue;
  color: white;
}
</style>
